const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/settings/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { useAuthStore } from '@/Utility/auth/Auth';
import { type RouteTo } from '@/Utility/hooks';
import { Box, Container, Skeleton } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import './Settings.less';
const SettingsFallback = () => <Container maxWidth="xl" className="Settings" sx={{
  mb: '0px'
}}>
    <Box className="SettingsContent" sx={{
    width: '100%',
    padding: 1
  }}>
      <Skeleton variant="rectangular" width="100%" height={50} sx={{
      margin: 1
    }} />
      <Skeleton variant="rectangular" width="100%" height={50} sx={{
      margin: 1
    }} />
      <Skeleton variant="rectangular" width="100%" height={50} sx={{
      margin: 1
    }} />
      <Skeleton variant="rectangular" width="100%" height={50} sx={{
      margin: 1
    }} />
      <Skeleton variant="rectangular" width="100%" height={50} sx={{
      margin: 1
    }} />
      <Skeleton variant="rectangular" width="100%" height={50} sx={{
      margin: 1
    }} />
    </Box>
  </Container>;
export const Route = createFileRoute('/dash/settings')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  pendingComponent: () => <SettingsFallback />,
  beforeLoad: ({
    location
  }) => {
    if (location.pathname === '/dash/settings') {
      const isAdmin = useAuthStore.getState()?.user?.isAdmin;
      if (isAdmin) {
        redirect({
          to: '/dash/settings/general/site-settings',
          throw: true
        });
      }
      redirect({
        to: '/dash/settings/management/profile',
        throw: true
      });
    }
  }
});